import PropTypes from 'prop-types';
import React from 'react';
import { formatMoney } from 'helpers/HelperFunctions';

const Price = ({ amount, currency, rounded, style }) => {
  if (amount < 0) {
    return <span style={style}>Negotiable</span>;
  }

  return <span style={style}>{formatMoney(amount, currency, !rounded)}</span>;
};

Price.propTypes = {
  amount: PropTypes.number.isRequired,
  currency: PropTypes.oneOf(['usd', 'gbp', 'eur', '']).isRequired,
  rounded: PropTypes.bool,
  style: PropTypes.object,
};

export default Price;
